/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

const PROFILE_BADGE_COLORS = {
  gray: '#64748b',
  pink: '#ec4899',
  red: '#ef4444',
  orange: '#f97316',
  green: '#22c55e',
  light_blue: '#38bdf8',
  purple: '#8b5cf6',
  teal: '#14b8a6',
  magenta: '#d946ef',
};

export const getProfileBadgeColor = (badge) => PROFILE_BADGE_COLORS[badge] || '#64748b';

export const getFallbackAcronym = (name = '') => {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
};

export const formatRestaurantsLabel = (restaurants = []) => {
  if (!restaurants.length) return '';

  if (restaurants.length === 1) {
    return restaurants[0]?.name || '';
  }

  return `${restaurants[0]?.name || ''} +${restaurants.length - 1}`.trim();
};

export const getGuestResultKey = (guest, index) => {
  if (guest?.id) {
    return String(guest.id);
  }

  const restaurantKey = guest?.restaurants
    ?.map((restaurant) => restaurant?.id || restaurant?.name)
    .filter(Boolean)
    .join('-');

  const fallbackParts = [
    guest?.name,
    guest?.phone_number,
    guest?.acronym,
    restaurantKey,
    index,
  ].filter((value) => value !== undefined && value !== null && value !== '');

  return fallbackParts.length ? fallbackParts.join('-') : `guest-result-${index}`;
};
